<template>
  <div class="header"  >
      <div class="path-guide">
          <div style="line-height:35px;margin-top:5px ;margin-right:20px; width:110px "> 
            <img style="height:35px; color:#409eff;width:100%; "   src="@/assets/title.png"/>
        </div>
          <i class="iconfont icon-mokuai" style="margin-right:10px;color:#fff"></i>
          <el-breadcrumb class="breadcrumb">
              
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                <span  style="color:#fff"> {{item.meta.title }}</span> 
              </el-breadcrumb-item>
          </el-breadcrumb>
      </div>
 
      <div class="option-bar">
            <el-link @click="aiBtn" v-if="userCol['ISAI']=='Y'" :underline="false" style="padding-right: 15px; padding-left:10px;color:#fFF;font-size:12px;font-weight:600" >       
              <i class="iconfont icon-wentizhaohui"></i>  <span style="border-bottom:2px solid green; ">AI 助手</span>
            </el-link> 
          <el-link @click="stkChart" :underline="false" style="padding-right: 15px; padding-left:10px;color:#fFF;font-size:12px;font-weight:600" >       
             <span style="border-bottom:1px solid #fff; ">仓库</span>
          </el-link>
          <el-link @click="saleChart" :underline="false" style="padding-right: 25px; padding-left:10px;color:#fFF;font-size:12px;font-weight:600" >       
             <span style="border-bottom:1px solid #fff">销售</span>
          </el-link> 
          <!-- <el-link @click="flowChart" :underline="false" style="padding-right: 15px; padding-left:10px;color:#fFF;font-size:12px;" >       
             <span style="border-bottom:1px solid #fff">销售</span>
          </el-link>  -->
    
          <el-tooltip  placement="bottom" v-model="tooltipVisible" manual effect="light" ref="tooltipRef" >
            <el-input size="small" @click.native="openTooltip"   v-model="filterText"   placeholder="请输入查询的功能名称" style="width:220px;margin-right:15px" ref="selectTreeInput" >  </el-input>
            <div slot="content" style="width:220px;height:360px;overflow-y:auto; " @click.stop> 
                <el-tree :data="treeData" 
                            :props="defaultProps" 
                            node-key="id"    
                            :default-expand-all="false"
                            :default-expanded-keys="['0']" 
                            :style="{background:'#fff',overflow:'auto',height:'400' }"
                            @node-click ="handleNodeClick" 
                            highlight-current
                            :filter-node-method="filterNode"
                            :expand-on-click-node="false"
                            ref="eltree">
                    <template v-slot="{node,data}">                                     
                        <span v-if="data.id ==0 "  >
                            <span  style="color:#F56C6C;font-size:14px;"><i class="iconfont icon-_shujuzidian" style="color:#F56C6C;font-size:18px;"></i> {{ node.label}} </span>
                        </span>                  
                        <span v-else  > 
                            <div :class="data.stfg=='Y'?'item-row2':'item-row'"  ><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i>{{ node.label}} </div>
                        </span>
                    </template>
                </el-tree>  
            </div>     
          </el-tooltip>  
          <div @click="noticeLog">
            <el-badge  :value="valNum"  style=" font-size:12px;margin-right:30px;padding-right:20px " class="custom-badge">
                <el-button size="small" type="text" @click="noticeLog" icon="iconfont icon-gonggao2" style="color:white"> </el-button>
            </el-badge>
          </div>
          <fullscreen v-model="isFullscreen" style="padding-right: 15px;margin-top:-10px;padding-left:10px;"/>  
          <el-link  href="javascript:void(0)" :underline="false" style="padding-right: 10px;padding-left:10px;color:#fFF;font-size:12px;" >       
              账套名称：{{ corpnm}}
          </el-link>   
  
          <div class="login-user">
              <Avatar icon="md-contact" :style="{background: '#5cadff'}"/>
              <Dropdown style="margin-left: 10px" transfer-class-name="login-user-dropdown">
                  <el-link href="javascript:void(0)" style="color:#fFF;font-size:12px;" :underline='false'>
                      {{loggedUser.name}}
                      <Icon type="ios-arrow-down"></Icon>
                  </el-link>
                  <DropdownMenu slot="list">
                      <div style="display:flex;justify-content:space-start;width:300px;flex-wrap:wrap" >
                        <DropdownItem  v-for="(item,index) in userSet" :key="index" >
                            <el-link :underline="false"   @click="logout(item.SUBNO)" style="color:#6495ED;font-size:12px">
                              <i class="iconfont icon-yuandianxiao" style="margin-right:3px;font-size:12px;color:red;" ></i>{{item.CNAME}}
                            </el-link>
                        </DropdownItem>
                      </div>
                  </DropdownMenu>
              </Dropdown>
          </div>
      </div>
 
      <el-dialog :visible.sync="userModel" width="600px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">基本信息</span>
        </div> 
        <div style="display:flex;line-height:40px;border-bottom:1px dashed #ccc">
            <div style="width:140px;text-align:right; ">账号编码:</div>
            <div style="width:240px;text-align:left;margin-left:20px;">{{userCol['USERNO']}}</div>
        </div> 
        <div style="display:flex;line-height:40px;border-bottom:1px dashed #ccc">
            <div style="width:140px;text-align:right; ">账号名称:</div>
            <div style="width:240px;text-align:left;margin-left:20px;">{{userCol['USERNM']}}</div>
        </div>
        <div style="display:flex;line-height:40px;border-bottom:1px dashed #ccc">
            <div style="width:140px;text-align:right; ">账套名称:</div>
            <div style="width:400px;text-align:left;margin-left:20px;">{{corpnm}}</div>
        </div>
        <div style="display:flex;line-height:40px;border-bottom:1px dashed #ccc">
            <div style="width:140px;text-align:right; ">主管理员:</div>
            <div style="width:340px;text-align:left;margin-left:20px;">{{userCol['ISADMIN']==='Y'?'是':'否'}}</div>
        </div>  
        <div style="display:flex;line-height:40px;border-bottom:1px dashed #ccc;margin-bottom:10px;">
            <div style="width:140px;text-align:right; ">注册日期:</div>
            <div style="width:340px;text-align:left;margin-left:20px;">{{userCol['ADDDTTM'] }}</div>
        </div>  
      </el-dialog>  
      <!-- 密码修改 -->
      <el-dialog :visible.sync="pwdModel" class="pub_dialog" width="600px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">      
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">修改密码</span>
        </div> 
        <Form  v-model="pwdform" :rules="pwdValidate" :label-width="110" ref="pwdform"  label-position="right" inline > 
            <FormItem  label="新密码"  class="row-width" prop="NEWPWD">                  
                <el-input  show-password
                           placeholder="请输入新密码(长度不少于6位)"
                           type="password"
                           v-model="NEWPWD"> 
                    <template slot ="prepend" ><i class="el-icon-lock" style="color:#409EFF"></i></template>
                </el-input>           
            </FormItem>
            <FormItem  label="确认密码"  class="row-width" prop="CFMPWD">                  
                <el-input  show-password
                           placeholder="请确认新密码(长度不少于6位)"
                           type="password"
                           v-model="CFMPWD"> 
                    <template slot ="prepend" ><i class="el-icon-lock" style="color:#409EFF"></i></template>
                </el-input>           
            </FormItem>
        </Form>
        <div style="height:40px;line-height:30px; padding-top:4px; border-top:2px solid #ccc;">
            <span style="float:right">
                <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="pwdModel=false" style="margin-right:50px;">取消</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="pwdCfm" style="margin-right:10px;">确定</el-button>           
            </span>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
        </div> 
        <div style="line-height:30px;display:flex">
            <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
            <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
        </div>
        <span slot="footer"  >
            <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {getBaseData } from '../api/user'; 
import {newTab} from '@/components/Home.vue' 
import Fullscreen from './fullscreen'
 
export default {
  data(){
    return {
        tooltipVisible: false ,// 控制 tooltip 显隐
        filterText:'',
        showDivList:false,
        treeData:[],
      isFullscreen: false,
      radiobool:false,
      corpnm:this.$cookies.get('v_corpnm'),    
      avatar:'assets/basedict/nopic.png',
      promptWin:false,
      prompt:'',  
      drawer:false,
      textbool:true,
      mylove:'我的最爱',
      loveitem:[], //用户最近点击明细
      loggedUser:{
          name: this.$cookies.get('v_usernm'),
          role:'管理员',
      },
 
      v_username:this.$cookies.get('v_telno'), //api 请求用户  
      pwdModel:false,
      userSet:[],
      flag :true,
      userModel :false,

        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            label: 'label',
            stfg:'stfg',
            idseq:'idseq',
        },
      userCol:{} , //用户设置--基本信息
      userArr:[],
      pwdform:{},
      CFMPWD:'',
      NEWPWD:'',
      valNum:0,
      pwdValidate: {NEWPWD:[{required:true,trigger:'blur',message:'新密码不能为空'}] ,
                     CFMPWD:[{required:true,trigger:'blur',message:'确认密码不能为空'}],
                     },                     
 
      v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
      wxsrc:'',
      telTag:'未绑定',
      mailTag:'未绑定',
      wxTag:'未绑定',
      qqTag:'未绑定',
    }
  },
  computed:{
    tabs () {
        return this.$store.state.tabs
    },
  },
  beforeDestroy() {
    // 销毁前移除监听，防止内存泄漏
    document.removeEventListener('click', this.handleClickOutside);
  },
  components:{
 
      Fullscreen,
  },
 
  mounted() {
    //查询该用户当前是否有未读的通知消息列表，如果有显示未读消息徽标
    //如果今天的、未读的消息中，有消息级别比较重要，可以弹出全局通知
    //this.checkNotices();
    //同时准备接收系统推送
    //this.enableBroadcastReceiver();
    // 设置初始语言
    //this.setLocal(this.$i18n.locale);
    // 挂载时添加全局点击监听
    document.addEventListener('click', this.handleClickOutside);
    // 用户最近访问表单
    this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'userno',p_value:this.v_username,p_table:'v_userlog' 
    }).then(res=>{
        this.loveitem=res.result
    })
    //用户菜单设置
    this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'parentno',p_value:'59',p_table:'V_sys_base' 
    }).then(res=>{
        this.userSet=res.result
    })
    this.getUserInfo()
 
    //用户基本信息字段
    this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'idseq',p_value:'24319',p_table:'v_sys_form_fld' ,p_cond:' order by sortby,lstseq'
    }).then(res=>{
        this.userArr=res.result
    })
 
    this.getQryList()
    this.getData()
  },
  watch: {
        filterText(val) {
            this.$refs.eltree.filter(val.toUpperCase())
        }
  },
  methods:{
    //  监听全局点击，实现点击外部关闭
    handleClickOutside(event) {
      // 如果 tooltip 已经是关闭状态，直接返回
      if (!this.tooltipVisible) return

      const tooltipRef = this.$refs.tooltipRef;
      const inputRef = this.$refs.selectTreeInput;
      
      // 获取 tooltip 的 popper DOM 元素 (Element UI 内部结构)
      // 注意：不同版本可能获取方式略有不同，通常可以通过 $refs 访问
      let isClickInside = false;

      // 判断点击是否在输入框内
      if (inputRef && inputRef.$el.contains(event.target)) {
        isClickInside = true;
      }
      
      // 判断点击是否在 tooltip 弹出层内
      // Element UI 的 tooltip popper 通常挂载在 body 下，需要通过 ref 获取其 popperVM
      if (tooltipRef && tooltipRef.popperVM) {
         const popperEl = tooltipRef.popperVM.$el;
         if (popperEl && popperEl.contains(event.target)) {
           isClickInside = true;
         }
      } else if (tooltipRef && tooltipRef.$el) {
         // 某些版本可能直接挂在 $el 或其子元素
         // 这里做一个兜底检查，防止报错
      }

      // 如果点击的不是输入框也不是 tooltip 内部，则关闭
      if (!isClickInside) {
        this.tooltipVisible = false;
      }
    },
    openTooltip() {
      this.tooltipVisible = true
    },
    aiBtn(){
        this.$store.commit('SET_SHOW_AI_CHAT', true)
    },
      getData() {  
            this.$axios.post('xuper_auth/getElTreeData', {
                p_table:'V_FORM_TREE',p_cond:''
            }).then(res=>{                  
                this.treeData =res.result            
            }) 
                                         
        },
      //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
      //节点点击
        handleNodeClick(data ){
            console.log(data.idseq,',click')
            if (data.icon!=='N' && data.stfg=='N'){
                this.$axios.post('xuper_auth/getBaseData', {
                   p_table:'v_sys_user_priv', p_key:'userno',p_value:this.v_username,p_key2:'issel',p_value2:'Y',p_key3:'frmidseq',p_value3:data.idseq
                }).then(res=>{ 
                    if (res.code =='200' ){
                        if (res.result.length>0){
                            this.filterText =''
                            this.showFlag=true 
                            this.$router.push({
                                path: data.icon , // '/sysmgt/show_chart',
                            }, () => {})
                        }else{
                            this.promptWin =true
                            this.prompt ='你的账号没有此权限，请联系管理员'
                        }
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }
                    // 点击节点后关闭 tooltip
                    this.tooltipVisible = false;
                })
            }
        },
      handleSelect(item) {
        console.log(item);
      },
      querySearch(queryString, cb) {
        // var restaurants = this.restaurants;
        // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // // 调用 callback 返回建议列表的数据
        // cb(results)
      },
      getQryList(){
            //待签收
 
            let v_cond =' and actdttm is null and instr(staff_no,\''+this.v_username+'\')>0 '
            this.$axios.post('xuper_auth/getBaseData', {
                p_key: 'corpid',p_value:this.v_corpid,p_table:'V_BS_WAIT_ITEM' ,p_cond: v_cond 
            }).then(res=>{ 
                if (res.code=='200'){
                    this.valNum=res.result.length    
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
      stkChart(){
          this.$router.push({
            path: '/sysmgt/stock_chart',
          }, () => {})
      },
      saleChart(){
          this.$router.push({
            path: '/sysmgt/ord_chart',
          }, () => {})
      },
      noticeLog(){
          this.$router.push({
            path: '/sysmgt/notice',
          }, () => {})
      },
    //用户信息
    getUserInfo(){
        this.$axios.post('xuper_auth/getBaseData', {
            p_key: 'userno',p_value:this.v_username,p_table:'v_sys_user' 
        }).then(res=>{
            this.userCol=res.result[0]
        })
    },
    //密码修改
    pwdCfm(){   
        let pwd_ =this.NEWPWD
        let cfmpwd_=this.CFMPWD
        if (!pwd_){
            this.prompt ='新密码不能为空'
            this.promptWin=true
        }else if (!cfmpwd_){
            this.prompt ='确认密码不能为空'
            this.promptWin=true
        }else{
            if(pwd_.length<6){
                this.prompt ='密码长度不能少于6位'
                this.promptWin=true
            }else if(cfmpwd_.length<6){
                this.prompt ='确认密码长度不能少于6位'
                this.promptWin=true
            }else if(pwd_!==cfmpwd_){
                this.prompt ='新密码和确认密码不匹配,请核查'
                this.promptWin=true
            }else{
                this.$axios.post('xuper_auth/updatePassword', {
                    p_value:this.v_username, p_table:'sys_user',p_value2:pwd_
                }).then(res=>{
                    this.userCol=res.result[0]
                    if(res.result ==='OK')  {          
                        this.pwdModel =false   
                    }else{
                        this.prompt =res.result
                        this.promptWin=true
                    } 
                })
                    
            }         
        }
    },
 
    //修改基本信息
    btnUser(){
        this.textbool =false
    },
 
    toggleLeftLayout(){
        this.flag =!this.flag
        this.$store.commit('toggleLeftLayout');
    },
    logout(data){
        if (data==='logout'){
            this.$confirm('你确定要退出系统吗？','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
 
                //回到登录页
                this.$router.replace('/');
            }).catch(()=>{})
        }else if (data==='securitySet'){  //安全设置
            this.userModel =true
        } else if (data==='modifyPwd'){  //密码设置
            this.pwdModel =true
            this.pwdform={}
        }
        else{
            this.$Message.info('编写功能页面进行中....')
        }
    },
 
    //检查通知
    checkNotices(){
    },
    //启用广播接收者（系统主动推送）
    enableBroadcastReceiver(){
        const that=this;
        //模拟websocket收到一条推送消息，先将header栏通知图标增加徽记
        //如果消息级别比较重要，开启全局通知
        setTimeout(()=>{
            that.notice('重要通知','这是一条测试消息');
        },10000);
    },
    //重要的全局通知，需要用户手动点击关闭
    notice(title,content){
        this.$Notice.open({
            title: title,
            desc: content,
            duration: 0
        });
    }
  }
}
</script>
<style lang="less">
    .custom-badge  .el-badge__content.is-fixed {
        left:-15px;
        top: 18px;
        padding-top:2px;
        width: 40px; /* 设置宽度 */
        height: 24px; /* 设置高度 */
        font-weight:600;
        cursor: pointer;
        font-size:13px;
    }
 
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .option-bar .login-user .login-user-dropdown{
        top:46px !important;
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .header{
    position: absolute;
    left:0;
    right:0;
    top:0;
    z-index: 30;
    color:white;
    padding: 0 20px 0 5px;
    align-items: center;
    height: 45px;
   // background-color: #388;
    background : radial-gradient(269px at -2.9% 12.9%, #808695 0%, #f7f8f9 46.4%,  #808695 100.7%);
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    display: flex;
    justify-content: space-between;
    .path-guide{
        display: flex;
        align-items: center;
        color:white;
        .icon-menu{margin-right: 20px;cursor: pointer}
        .icon-menu:hover{background-color:#f5f7f9 }
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            .breadcrumb{display: none}
        }
    }
    .option-bar{
        display: flex;
        align-items: center;
        .login-user{
            display: flex;
            align-items: center;
            font-size:12px;
            font-weight:500;
            padding: 0 0 0 20px;
        }
    }
  }
 
  .flex{
      display:flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 30px;
  }

  .line-img{
    margin-right:4px;
    width:130px;
    height:130px;
    text-align:center;
    vertical-align:middle;
    display:inline-block;
}
 
a:visited{
	color:dark-green;
}
a:hover{
	color:rgb(175, 128, 128);
}
a:active{
	color:dark-red;
}
.item-width  {
     width: 48%;
     color:#409EFF;
  }
  .row-width  {
     width: 97%;
  }
 
</style>
